export const brandingConfig = {
  company: {
    name: "ERP",
    tagline: "Systeme ERP",
    description: "Application de gestion complète",
    logo: "/images/logo.png",
  },

  links: {
    website: "https://votre-site.com",
    support: "mailto:support@votre-site.com",
    documentation: "http://localhost:8000/admin/",
    github: "https://github.com/votre-repo",
  },

  images: {
    logo: "/images/logo.png",
    logoSmall: "/images/logo-small.png",
    background: "/images/background.jpg",
    loginSidebar: "/images/login-bg.jpg",
    avatar: "/images/default-avatar.png",
  },

 colors: {
    primary: "#1976d2",
    secondary: "#dc004e",
    accent: "#4a90e2",
    accentDark: "#357abd",
    background: "#f5f5f5",
    surface: "#ffffff",
  },

  authColors: {
    background: "#1a1d2e",
    card: "#22283a",
    inputBg: "#1a1d2e",
    border: "rgba(255,255,255,0.08)",
    text: "#e4e6eb",
    muted: "rgba(255,255,255,0.5)",
    button: "#2c3448",
    buttonHover: "#364057",
    outline: "rgba(100,150,250,0.15)",
  },

  texts: {
    appTitle: "ERP",
    loginTitle: "Connexion",
    loginSubtitle: "Accédez à l'interface de gestion ERP",
    dashboardTitle: "Tableau de bord",
    welcomeMessage: "Bienvenue dans votre espace de gestion",
    footerText: "ERP • Django + React + Material-UI",
  },

  features: [
    {
      title: "Gestion des Clients",
      description: "CRUD complet pour les clients et contacts",
      icon: "users",
      path: "/clients",
    },
    {
      title: "Gestion des Tâches",
      description: "Tableau Kanban pour le suivi des travaux d'impression",
      icon: "items",
      path: "/kanban",
    },
    {
      title: "Soumissions & Factures",
      description: "Gestion des devis, factures et bons de livraison",
      icon: "security",
      path: "/soumissions",
    },
  ],

  techStack: [
    "Backend Django 5.1 + Wagtail CMS",
    "Frontend React 18 + TypeScript",
    "Material-UI 5 Design System",
    "JWT Authentication (SimpleJWT)",
    "Django REST Framework",
    "Role-based Access Control",
    "PostgreSQL Database",
    "TanStack Query",
  ],

  demo: {
    enabled: true,
    username: "admin",
    password: "admin",
    showCredentials: false,
  },
};

export const { company, links, images, colors, texts, features, techStack, demo, authColors } = brandingConfig;